export default __webpack_public_path__ + "static/media/about-6.cfc268aa.png";